import React from "react";
import { Card, Row, Col, Space, Button, Spin } from "antd";
import { EnvironmentOutlined, FormOutlined, UnorderedListOutlined, SaveOutlined } from "@ant-design/icons";
import CardPage from "../../layout/CardPage";
import { FormularioOrigenDestino } from "./features/FormularioOrigenDestino/FormularioOrigenDestino";
import { DatosServicio } from "./features/DatosServicio/DatosServicio";
import { CamposServicio } from "./features/CamposServicio/CamposServicio";
import { InfoAsistencia } from "./features/InfoAsistencia/InfoAsistencia";
import { InformacionCampaniaDrawer } from "./features/InformacionCampania/InformacionCampaniaDrawer";
import { useEditarServicioV2 } from "./hooks/useEditarServicioV2";
import "./shared/crearServiciosV2.css";

export const EditarServicioV2 = () => {
  const {
    asistenciaID,
    validandoAcceso,
    valoresCampos,
    loadingTerminar,
    ubicacionGuardada,
    setUbicacionGuardada,
    datosServicioRef,
    handleInputChange,
    handleSelectChange,
    handleCampoChange,
    handleTerminar,
    campaniaID,
    tieneErroresCaptura,
    datosAdicionales,
  } = useEditarServicioV2();

  if (validandoAcceso) {
    return (
      <CardPage titulo="Editar Servicio">
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin />
        </div>
      </CardPage>
    );
  }

  return (
    <CardPage titulo="Editar Servicio">
      <div className="crear-servicios-v2">
        <Row gutter={[24, 24]}>
          <Col xs={24} lg={16}>
            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
              <InfoAsistencia asistenciaID={asistenciaID} />

              <Card size="small">
                <div className="crear-servicios-v2__section-header">
                  <div className="crear-servicios-v2__section-header-title">
                    <EnvironmentOutlined />
                    <span>Ubicación</span>
                  </div>
                </div>
                <FormularioOrigenDestino
                  asistenciaID={asistenciaID}
                  onGuardado={() => setUbicacionGuardada(true)} />
              </Card>
              {ubicacionGuardada && (
                <Card size="small" ref={datosServicioRef}>
                  <div className="crear-servicios-v2__section-header">
                    <div className="crear-servicios-v2__section-header-title">
                      <FormOutlined />
                      <span>Datos del Servicio</span>
                    </div>
                  </div>
                  <DatosServicio
                    handleInputChange={handleInputChange}
                    handleSelectChange={handleSelectChange}
                  />
                </Card>
              )}

              {ubicacionGuardada && (
                <Card size="small">
                  <div className="crear-servicios-v2__section-header">
                    <div className="crear-servicios-v2__section-header-title">
                      <UnorderedListOutlined />
                      <span>Campos del Servicio</span>
                    </div>
                  </div>
                  <CamposServicio
                    valoresCampos={valoresCampos}
                    onCampoChange={handleCampoChange}
                    datosAdicionales={datosAdicionales}
                    onDatosAdicionalesChange={handleInputChange("datosAdicionales")}
                  />
                </Card>
              )}
            {ubicacionGuardada && (
              <Row>
                <Col xs={24} sm={{ span: 8, offset: 16 }}>
                  <Button
                    type="primary"
                    icon={<SaveOutlined />}
                    block
                    size="large"
                    loading={loadingTerminar}
                    onClick={handleTerminar}
                    disabled={tieneErroresCaptura || loadingTerminar}
                  >
                    Terminar Captura
                  </Button>
                </Col>
              </Row>
            )}
            </Space>
          </Col>
          <Col xs={24} lg={8}>
            {campaniaID && <InformacionCampaniaDrawer campaniaID={campaniaID} />}
          </Col>
        </Row>
      </div>
    </CardPage>
  );
};
